import { render, staticRenderFns } from "./SearchbarFilterSuggestion.vue?vue&type=template&id=b4bfa88a&scoped=true&"
import script from "./SearchbarFilterSuggestion.vue?vue&type=script&lang=ts&"
export * from "./SearchbarFilterSuggestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bfa88a",
  null
  
)

export default component.exports